export const tracksList = getters => {
  return getters.tracksList
}

export const getManagingTrack = getters => {
  return getters.manageTrack
}
